var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProductFilter = function SvgProductFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.4375H7.5C7.5 9.47156 8.34094 10.3125 9.375 10.3125H11.25C12.2841 10.3125 13.125 9.47156 13.125 8.4375H26.25C26.7675 8.4375 27.1875 8.01844 27.1875 7.5C27.1875 6.98156 26.7675 6.5625 26.25 6.5625H13.125C13.125 5.52844 12.2841 4.6875 11.25 4.6875H9.375C8.34094 4.6875 7.5 5.52844 7.5 6.5625H3.75C3.2325 6.5625 2.8125 6.98156 2.8125 7.5C2.8125 8.01844 3.2325 8.4375 3.75 8.4375Z",
    fill: "#06383F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 14.0625H20.625C20.625 13.0284 19.7841 12.1875 18.75 12.1875H16.875C15.8409 12.1875 15 13.0284 15 14.0625H3.75C3.2325 14.0625 2.8125 14.4816 2.8125 15C2.8125 15.5184 3.2325 15.9375 3.75 15.9375H15C15 16.9716 15.8409 17.8125 16.875 17.8125H18.75C19.7841 17.8125 20.625 16.9716 20.625 15.9375H26.25C26.7675 15.9375 27.1875 15.5184 27.1875 15C27.1875 14.4816 26.7675 14.0625 26.25 14.0625Z",
    fill: "#06383F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 21.5625H13.125C13.125 20.5284 12.2841 19.6875 11.25 19.6875H9.375C8.34094 19.6875 7.5 20.5284 7.5 21.5625H3.75C3.2325 21.5625 2.8125 21.9816 2.8125 22.5C2.8125 23.0184 3.2325 23.4375 3.75 23.4375H7.5C7.5 24.4716 8.34094 25.3125 9.375 25.3125H11.25C12.2841 25.3125 13.125 24.4716 13.125 23.4375H26.25C26.7675 23.4375 27.1875 23.0184 27.1875 22.5C27.1875 21.9816 26.7675 21.5625 26.25 21.5625Z",
    fill: "#06383F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product_filter.a9d46d5a.svg";
export { ForwardRef as ReactComponent };